import api from "@/shared/services/api";
import store from "@/store/app";
import { getStore } from "@/store";
export async function sendLeadApi(data, showModal = false, isConstructionCompany = false) {
    let url = isConstructionCompany
        ? process.env.VUE_APP_CALCULATOR_CC_LEAD
        : process.env.VUE_APP_CALCULATOR_LEAD;
    if (process.env.VUE_APP_IS_WIDGET === "false" &&
        !getStore().state.user.userLogged) {
        url = isConstructionCompany
            ? process.env.VUE_APP_GUEST_CALCULATOR_CC_LEAD
            : process.env.VUE_APP_GUEST_CALCULATOR_LEAD;
    }
    return await api
        .post(url, data)
        .then((res) => {
        if (data.action_id === 5 && showModal) {
            const dataForModal = {
                status: res.data.status,
                successText: "Ваша заявка отправлена",
                errorMessage: res.data.message,
                isValidationErrors: false,
            };
            store.dispatch("common/openInfoModal", dataForModal);
        }
        return Promise.resolve(true);
    })
        .catch((error) => {
        if (error.response.status === 500 ||
            error.response.status === 403 ||
            error.response.status === 404 ||
            error.response.status === 502) {
            store.dispatch("openAlertError", error);
        }
        const validationErrors = error?.response?.data?.validationErrors;
        if (validationErrors?.length) {
            return Promise.reject(validationErrors[0].error);
        }
    });
}
